import {z} from 'zod';
import {specificationSchema} from './specification.model';
import {zNumberToString} from '@brunata-angular/util';

export const costGroupSchema = z.object({
    groupName: z.string().nullable(),
    groupNo: z.number().nullable(),
    wbCostGroupId: zNumberToString.nullable(),
    costSpecifications: z.array(specificationSchema),
    costGroupId: zNumberToString.nullable(),
    disabled: z.boolean(),
});

export type CostGroup = z.infer<typeof costGroupSchema>;
